import React from "react";
import { Box, List, ListItem, Typography, useTheme } from "@mui/material";

import { granite } from "../../design-system/colors";
import { useScreenSize } from "../../globals/hooks";
import { usePrivacyPolicy } from "../new/hooks/usePrivacyPolicy";

/**
 * NOTE: When making any updates to the privacy policy, please update the LAST_UPDATED_DATE
 */
const LAST_UPDATED_DATE = "February 17, 2026";

function PrivacyPolicyPage() {
  const theme = useTheme();
  const { isMobileView } = useScreenSize();
  const privacyPolicy = usePrivacyPolicy();

  return (
    <Box
      mx={isMobileView ? 0 : "auto"}
      sx={{
        [theme.breakpoints.down(undefined)]: {
          padding: `0 ${theme.spacing(11)}`,
        },
        [theme.breakpoints.down("sm")]: {
          padding: `0 ${theme.spacing(2)}`,
        },
      }}
      maxWidth="1140px"
    >
      <Box pt={isMobileView ? 3 : 7} pb={isMobileView ? 2 : 4}>
        <Typography
          sx={{
            [theme.breakpoints.up(380)]: {
              fontSize: "1.8rem",
            },
            [theme.breakpoints.down(undefined)]: {
              fontSize: "1.5rem",
            },
          }}
          variant={isMobileView ? "h1" : "h2"}
        >
          Privacy Policy
        </Typography>
        <Typography
          variant="body2"
          sx={{ mt: 1, color: granite }}
        >
          Last updated: {LAST_UPDATED_DATE}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection={isMobileView ? "column-reverse" : "row"}
      >
        <Box width={isMobileView ? "100%" : "60vw"} flex={2} mr={10}>
          <List>
            {privacyPolicy.map(({ id, name, description }) => (
              <ListItem disableGutters key={id}>
                <Box id={id} display="flex" flexDirection="column" mb={2}>
                  <Box mb={2}>
                    <Typography variant="h3">{name}</Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    {description}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Box>
  );
}
export default PrivacyPolicyPage;